const baseAppProxy = "https://console-shopify.ringbuilder.io";
const shopifyFileURL = 'https://cdn.shopify.com/s/files/1/0686/8995/3069/files';
let ajaxCallDiamondListRunning = 'No', myCustomController = null,
    selectedFilterValueShapeElement = document.querySelector('[data-selected-filter-value-shape]') && document.querySelector('[data-selected-filter-value-shape]'),
    selectedFilterValueCaratElement = document.querySelector('[data-selected-filter-value-carat]') && document.querySelector('[data-selected-filter-value-carat]'),
    selectedFilterValueColorElement = document.querySelector('[data-selected-filter-value-color]') && document.querySelector('[data-selected-filter-value-color]'),
    selectedFilterValueClarityElement = document.querySelector('[data-selected-filter-value-clarity]') && document.querySelector('[data-selected-filter-value-clarity]'),
    selectedFilterValuePriceElement = document.querySelector('[data-selected-filter-value-price]') && document.querySelector('[data-selected-filter-value-price]');

const activeShopifyCurrency = Shopify?.currency?.active || "USD";

window.DIAMOND_PLP_SETTING = function () {
    return {
        config: {
            page_number: 1
        },
        fetchData: async (params) => {
            if (myCustomController !== null) {
                myCustomController.abort();
            }

            myCustomController = new AbortController();
            const myCustomSignal = myCustomController.signal;

            return await fetch(`${baseAppProxy}/frontend.php`, {
                signal: myCustomSignal,
                method: "POST",
                body: params,
            })
            .then((response) => response.json())
            .then((result) => result)
            .catch((error) => error);
        },
        callBeforeDiamond: async function () {
            if (myCustomController !== null) {
                myCustomController.abort();
            }
            
            this.config.page_number = 1;
            ajaxCallDiamondListRunning = 'No';
            document.querySelector("[data-collection-grid-html]") && (document.querySelector("[data-collection-grid-html]").innerHTML = "");
            document.querySelector("[data-collection-list-html]") && (document.querySelector("[data-collection-list-html]").innerHTML = "");
            await this?.callDiamondList();
        },
        callDiamondList: async function () {
            /**
             * Selected Filter Values
            */
            selectedFilterValueShapeElement.innerText = this?.config?.shapeValue;
            selectedFilterValueCaratElement.innerText = `${this?.config?.caratMin} - ${this?.config?.caratMax}`;
            if(this?.config?.fancyValue!=""){
                selectedFilterValueColorElement.innerText = this?.config?.fancyValue;
            }else{
                selectedFilterValueColorElement.innerText = this?.config?.colorValues.replace(',', ' - ');
            }
            
            selectedFilterValueClarityElement.innerText = this?.config?.clarityValues.replace(',', ' - ');
            selectedFilterValuePriceElement.innerText = `${HackWrapper.formatMoney(this?.config?.priceMin*100)} - ${HackWrapper.formatMoney(this?.config?.priceMax*100)}`;

            history.replaceState(null, '', HackWrapper.upsertQueryParams('shape', DIAMOND_PLP_SETTING?.config?.shapeValue));

            if (ajaxCallDiamondListRunning == 'No') {
                ajaxCallDiamondListRunning = 'Yes';
                HackWrapper.showElements('.load-more-div');

                var formData = new FormData();
                formData.append("action", "get_labgrown_list");
                formData.append("shop", Shopify.shop);
                formData.append("page_number", Number(this?.config.page_number));

                formData.append("shape_data", this?.config?.shapeValue);
                formData.append("clarity_data_wrap", this?.config?.clarityValues);
                formData.append("cut_data_wrap", this?.config?.shapeValue == "Round" ? this?.config?.cutValues : '');
                formData.append("symmetry_data_wrap", this?.config?.symmetryValues);
                formData.append("lab_data", this?.config?.labValues);
                if(this?.config?.fancyValue!=""){
                    formData.append("fcolor_data_wrap", this?.config?.fancyValue);
                }else{
                    formData.append("color_data_wrap", this?.config?.colorValues);
                }
                
                formData.append("carat_min", Number(this?.config?.caratMin));
                formData.append("carat_max", Number(this?.config?.caratMax));

                formData.append("min_price", Math.round(Currency.convert(Number(this?.config?.priceMin), activeShopifyCurrency, 'USD')));
                formData.append("max_price", Math.round(Currency.convert(Number(this?.config?.priceMax), activeShopifyCurrency, 'USD')));

                formData.append("min_table", Number(this?.config?.tableMin));
                formData.append("max_table", Number(this?.config?.tableMax));

                formData.append("min_depth", Number(this?.config?.depthMin));
                formData.append("max_depth", Number(this?.config?.depthMax));

                formData.append("meas_ratio_from", Number(this?.config?.ratioMin));
                formData.append("meas_ratio_to", Number(this?.config?.ratioMax));

                formData.append("tab_view", document.querySelector('button.filter-icons.set_tab_view.active').dataset.view.toLocaleLowerCase());
                formData.append('with_images', true);
                formData.append('with_videos', true);
                formData.append("sorting_field", this?.config?.sortingField);
                formData.append("sorting_seq", this?.config?.sortingSeq);
                formData.append('location_data_wrap', 'Surat,New York,India,Mumbai,Chicago,Texas,Los Angeles');

                const products = await this.fetchData(formData);
                if (Object.keys(products)?.length > 0) {
                    let diamondsArray = products?.main_data?.response?.body?.diamonds || [];
                    if (diamondsArray.length > 0) {
                        DIAMOND_PLP_SETTING.config.page_number = Number(this?.config.page_number)+1;

                        ajaxCallDiamondListRunning = 'No';
                        let errorSrc = `this.src='${shopifyFileURL}/no-image.png'`;
                        let staticHandle = HackWrapper.getUrlParameter('ring-handle') !== undefined ? HackWrapper.getUrlParameter('ring-handle') : '';

                        var htmlGrid, htmlList;
                        for (x = 0; x < (diamondsArray.length); x++) {
                            const diamondsObject = diamondsArray[x];
                            const dynamic_id = `pro-data-${diamondsObject.id}`;

                            let pdpBaseURL = `/products/stone-details?stone-stock=${diamondsObject?.stock_num}&steps=settings`;
                            let ringProductURL = `/collections/solitaire-engagement-rings?stone-stock=${diamondsObject?.stock_num}&filter.p.m.custom.stone_shape=${diamondsObject?.shape}&steps=settings`;
                            if (HackWrapper.getUrlParameter('ring-handle') !== undefined) {
                                pdpBaseURL = `/products/stone-details?stone-stock=${diamondsObject?.stock_num}`;
                                ringProductURL = `/products/${staticHandle}?stone-stock=${diamondsObject?.stock_num}`;
                                pdpBaseURL += `&ring-handle=${staticHandle}`;
                                if (HackWrapper.getUrlParameter('review') !== undefined) {
                                    ringProductURL += `&review=true`;
                                    pdpBaseURL += `&review=true`;
                                }
                            }                            

                            var measurements_arr = [];
                            if (diamondsObject?.meas_length != null && diamondsObject?.meas_length != '') {
                                measurements_arr.push(diamondsObject?.meas_length);
                            } else {
                                measurements_arr.push('0.00');
                            }
                            if (diamondsObject?.meas_width != null && diamondsObject?.meas_width != '') {
                                measurements_arr.push(diamondsObject?.meas_width);
                            } else {
                                measurements_arr.push('0.00');
                            }
                            if (diamondsObject?.meas_depth != null && diamondsObject?.meas_depth != '') {
                                measurements_arr.push(diamondsObject?.meas_depth);
                            } else {
                                measurements_arr.push('0.00');
                            }
                            var measurements = measurements_arr.join('x');

                            htmlGrid = `<div class="clair-card">
                                <textarea id="${dynamic_id}-textarea" style="display:none;">${JSON.stringify(diamondsObject)}</textarea>
                                <a href="${HackWrapper.getUrlParameter('ring-handle') !== undefined ? ringProductURL : pdpBaseURL}">
                                    <img src="${diamondsObject?.image_url}" onerror="${errorSrc}" alt="${diamondsObject?.short_title}">
                                    <div class="clair-card-info">
                                        <div class="clair-title">${diamondsObject.size} Carat ${diamondsObject.shape} Lab-Created Diamond</div>
                                        <div class="clair-details">Color: ${diamondsObject.color} <span>•</span> Clarity: ${diamondsObject.clarity} <span>•</span>  Cut: ${diamondsObject.cut}</div>
                                        <div class="clair-price">${diamondsObject?.total_sales_price?.length > 0 ? HackWrapper.formatMoney(HackWrapper.convertToShopCurrency(Number(diamondsObject?.total_sales_price) * 100)) : "-"}<span>Stone Price</span></div>
                                    </div>
                                </a>
                            </div>`;
                            document.querySelector('[data-collection-grid-html]').innerHTML += htmlGrid;

                            let svgURL = diamondsObject?.shape?.length > 0 ? `${shopifyFileURL}/icon-shape-${HackWrapper.handleize(diamondsObject?.shape)}.svg` : `${shopifyFileURL}/no-image.png`;

                            let colorTitle = '-';
                            if (diamondsObject?.is_fancy==false) {
                                colorTitle = diamondsObject?.color;
                            } else {
                                colorTitle = (diamondsObject?.fancy_color_intensity_short || "") +" "+ (diamondsObject?.fancy_color_overtone_short || "") +" "+ (diamondsObject?.fancy_color_short || "");
                            }
                            colorTitle = colorTitle.trim();

                            htmlList = `<tr class="clair-list-item clair-list-first-item collection__results-list-action" data-list-id="list-view-product-${diamondsObject?.id}" data-id="${dynamic_id}" data-image="${diamondsObject?.image_url}" data-onerror="${errorSrc}" data-video="${diamondsObject?.video_url?.length > 0?diamondsObject?.video_url:''}" data-display="true">
                                <td class="clair-shape">
                                    <img src="${svgURL}" alt="Diamond" class="clair-img" width="22px" height="38px">
                                    <span class="clair-oval-shape">${diamondsObject.shape}</span>
                                </td>
                                <td class="clair-details">${diamondsObject?.size?.length > 0 ? diamondsObject?.size + 'ct' : '-'}</td>
                                <td class="clair-details">${colorTitle}</td>
                                <td class="clair-details">${diamondsObject?.clarity?.length > 0 ? diamondsObject?.clarity : '-'}</td>
                                <td class="clair-details">${diamondsObject?.cut?.length > 0 ? diamondsObject?.cut : '-'}</td>
                                <td class="clair-details">${diamondsObject?.total_sales_price?.length > 0 ? HackWrapper.formatMoney(HackWrapper.convertToShopCurrency(Number(diamondsObject?.total_sales_price) * 100)) : "-"}</td>
                            </tr>
                            <tr class="clair-detail-view-section hidden" id="list-view-product-${diamondsObject?.id}">
                                <td colspan="6" class="full-width-row">
                                    <div class="diamond-detail-box">
                                        <div class="product-image product-image-frame" data-type="video" data-video_url="${diamondsObject?.video_url}">
                                            <img class="${dynamic_id}-image-desk" src="${diamondsObject?.image_url}" onerror="${errorSrc}" alt="${diamondsObject?.short_title}" width="450px">
                                            ${diamondsObject?.video_url?.length > 0 ? '<iframe width="100%" class="'+dynamic_id+'-video-desk" src="" style="opacity:0;" frameborder="0" allow="autoplay"></iframe>' : ""}
                                            ${diamondsObject?.video_url?.length > 0 ? (`<span class="icon-wrapper play-button play_button">
                                                <svg class="icon-circle-play" width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M7.5 0C9.50368 0 11.3866 0.78016 12.8037 2.19727C14.2208 3.61436 15 5.49734 15 7.50098C15 9.50459 14.22 11.3874 12.8037 12.8037C11.3874 14.22 9.50368 15 7.5 15C5.49632 15 3.61339 14.22 2.19629 12.8037C0.779228 11.3874 4.84786e-05 9.5038 0 7.50098C0 5.49734 0.780033 3.61436 2.19629 2.19727C3.6126 0.78016 5.49632 0 7.5 0ZM7.5 0.789062C3.79974 0.789063 0.789063 3.79974 0.789062 7.5C0.789062 11.2003 3.79974 14.2109 7.5 14.2109C11.2003 14.2109 14.2109 11.2003 14.2109 7.5C14.2109 3.79974 11.2003 0.789062 7.5 0.789062Z" fill="black"></path>
                                                    <path d="M4.94141 3.20799C5.06677 3.13869 5.21936 3.14223 5.34082 3.21775L11.6572 7.16502C11.7725 7.23685 11.8428 7.36421 11.8428 7.49998C11.8428 7.63575 11.7725 7.76309 11.6572 7.83494L5.34082 11.7822C5.27696 11.8223 5.20434 11.8418 5.13184 11.8418C5.06643 11.8417 5.00052 11.825 4.94141 11.792C4.81588 11.7225 4.7373 11.5901 4.7373 11.4472V3.55271C4.7373 3.40903 4.81588 3.27746 4.94141 3.20799ZM5.52637 10.7353L10.7031 7.49998L5.52637 4.26463V10.7353Z" fill="black"></path>
                                                </svg>
                                            </span>`):''}

                                            <span class="icon-wrapper play-button image_button" style="display:none;">
                                                <svg class="icon-circle-play" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <path d="M13.5 9c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5-1.122 2.5-2.5 2.5zM13.5 5c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5 1.5-0.673 1.5-1.5-0.673-1.5-1.5-1.5z" fill="#000000"></path>
                                                    <path d="M18.5 0h-17c-0.827 0-1.5 0.673-1.5 1.5v17c0 0.827 0.673 1.5 1.5 1.5h17c0.827 0 1.5-0.673 1.5-1.5v-17c0-0.827-0.673-1.5-1.5-1.5zM1 18.5v-4.807l4.197-4.617c0.085-0.093 0.196-0.145 0.314-0.147s0.231 0.048 0.318 0.139l9.5 9.932h-13.83c-0.276 0-0.5-0.224-0.5-0.5zM19 18.5c0 0.276-0.224 0.5-0.5 0.5h-1.786l-10.161-10.623c-0.281-0.294-0.655-0.452-1.053-0.447s-0.768 0.173-1.042 0.474l-3.457 3.803v-10.707c0-0.276 0.224-0.5 0.5-0.5h17c0.276 0 0.5 0.224 0.5 0.5v17z" fill="#000000"></path>
                                                </svg>
                                            </span>
                                        </div>
                                        <div class="diamond-details-wrapper">
                                            <button class="clair-tr-close collection__results-list-action" data-list-id="list-view-product-${diamondsObject?.id}" data-id="${dynamic_id}" data-display="false">✕</button>
                                            <div class="top-row">
                                                <div class="top-left">
                                                    <h2 class="diamond-title">${diamondsObject?.size?.length > 0 ? diamondsObject?.size : '-'} Carat ${diamondsObject.shape} <br> Lab-Created Diamond</h2>
                                                    <p class="diamond-price">${diamondsObject?.total_sales_price?.length > 0 ? HackWrapper.formatMoney(HackWrapper.convertToShopCurrency(Number(diamondsObject?.total_sales_price) * 100)) : "-"} &nbsp;&nbsp; Stone Price</p>
                                                </div>
                                                <div class="top-right">
                                                    <a class="btn add-btn add-to-cart" href="${ringProductURL}">${HackWrapper.getUrlParameter('ring-handle') !== undefined ? 'Select': 'Add to Ring'}</a>
                                                    ${HackWrapper.getUrlParameter('ring-handle') === undefined ? `<a href="javascript:void(0)" style="display:none;" class="btn outline-btn purchase add-to-cart" data-select-item="${dynamic_id}">Purchase Without Setting</a>`:""}
                                                    <a href="${pdpBaseURL}" class="view-details">View Full Stone Details</a>
                                                </div>
                                            </div>
                                            <!-- Carat / Color / Cut / Clarity -->
                                            <div class="details-grid">
                                                <div><strong>Carat:</strong> <span>${diamondsObject?.size?.length > 0 ? diamondsObject?.size + 'ct' : '-'}</span></div>
                                                <div><strong>Color:</strong> <span>${colorTitle}</span></div>
                                                <div><strong>Cut:</strong> <span>${diamondsObject?.cut?.length > 0 ? diamondsObject?.cut : '-'}</span></div>
                                                <div><strong>Clarity:</strong> <span>${diamondsObject?.clarity?.length > 0 ? diamondsObject?.clarity : '-'}</span></div>
                                            </div>
                                            <!-- Accordion -->
                                            <div class="accordion-container" id="additionalDetails-${diamondsObject?.id}">
                                                <button class="accordion-toggle accordion-details-action-custom">Additional Details 
                                                    <span class="accordion-icon">
                                                        <svg width="12" height="7" viewBox="0 0 12 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M0.000631604 5.99978C0.000631604 6.08062 0.0315802 6.16147 0.0928458 6.22336C0.216009 6.34653 0.416227 6.34653 0.53939 6.22336L6.00024 0.762516L11.4611 6.22336C11.5842 6.34653 11.7845 6.34653 11.9076 6.22336C12.0308 6.1002 12.0308 5.89998 11.9076 5.77682L6.22319 0.0923839C6.10003 -0.0307789 5.89981 -0.0307789 5.77665 0.0923839L0.0922142 5.77682C0.030317 5.83872 0 5.91956 0 6.00041L0.000631604 5.99978Z" fill="black"/>
                                                        </svg>
                                                    </span>
                                                </button>
                                                <div class="accordion-content">
                                                    <div class="details-grid">
                                                        ${diamondsObject?.polish?.length > 0 ? `<div><strong>Polish:</strong> ${diamondsObject?.polish} </div>` : ""}
                                                        ${diamondsObject?.symmetry?.length > 0 ? `<div><strong>Symmetry:</strong> ${diamondsObject?.symmetry} </div>` : ""}
                                                        ${diamondsObject?.fluor_intensity?.length > 0 ? `<div><strong>Fluorescence:</strong> ${diamondsObject?.fluor_intensity} </div>` : ""}
                                                        ${diamondsObject?.lab?.length > 0 ? `<div><strong>Lab:</strong> ${diamondsObject?.lab} </div>` : ""}
                                                        ${diamondsObject?.cert_num?.length > 0 ? `<div><strong>Report #:</strong> ${diamondsObject?.cert_num} </div>` : ""}
                                                        ${diamondsObject?.culet_size?.length > 0 ? `<div><strong>Culet:</strong> ${diamondsObject?.culet_size} </div>` : ""}
                                                        ${measurements?.length > 0 ? `<div><strong>Measurement:</strong> ${measurements} </div>` : ""}
                                                        ${diamondsObject?.meas_ratio?.length > 0 ? `<div><strong>Ratio:</strong> ${diamondsObject?.meas_ratio} </div>` : ""}
                                                        ${diamondsObject?.treatment?.length > 0 ? `<div><strong>Treatment:</strong> ${diamondsObject?.treatment} </div>` : ""}
                                                        ${diamondsObject?.table_percent > 0 ? `<div><strong>Table %:</strong> ${diamondsObject?.table_percent} </div>` : ""}
                                                        ${diamondsObject?.girdle_condition?.length > 0 ? `<div><strong>Girdle:</strong> ${diamondsObject?.girdle_condition} </div>` : ""}
                                                        ${diamondsObject?.depth_percent?.length > 0 ? `<div><strong>Depth %:</strong> ${diamondsObject?.depth_percent} </div>` : ""}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </td>
                            </tr>`;
                            document.querySelector('[data-collection-list-html]').innerHTML += htmlList;
                        }

                        this.initCollapseListView();
                        this.initAddToCartButton();
                    } else {
                        if (this?.config?.page_number == 1) {
                            document.querySelector("[data-collection-grid-html]") && (document.querySelector("[data-collection-grid-html]").innerHTML += '<div class="no-results"><p>No diamonds meets your filter criteria.</p></div>');
                            document.querySelector("[data-collection-list-html]") && (document.querySelector("[data-collection-list-html]").innerHTML += '<tr class="no-results"><td colspan="6"><p>No diamonds meets your filter criteria.</p></td></tr>');
                        }
                    }
                    HackWrapper.hideElements('.load-more-div');
                } else {
                    HackWrapper.hideElements('.load-more-div');
                }
            }
        },
        initShowAndHideIframe: function () {
            let productImageFrameElements = HackWrapper.getElements('.product-image-frame');
            for (let element of productImageFrameElements) {
                element.querySelector('img') && (element.querySelector('img').style.display = '');
                element.querySelector('iframe') && (element.querySelector('iframe').style.opacity = 0);
                element.querySelector('iframe') && (element.querySelector('iframe').classList.remove('video-active'));
                element.querySelector('.play_button') && (element.querySelector('.play_button').style.display = 'flex');
                element.querySelector('.image_button') && (element.querySelector('.image_button').style.display = 'none');
                element.querySelector('.product__image_inner') && (element.querySelector('.product__image_inner').style.display = '');

                element.addEventListener('click', function(event) {
                    const btnType = this.dataset.type;
                    productImageFrameElements.forEach(e => {
                        e.querySelector('img') && (e.querySelector('img').style.display = '');
                        e.querySelector('iframe') && (e.querySelector('iframe').style.opacity = 0);
                        e.querySelector('iframe') && (e.querySelector('iframe').classList.remove('video-active'));
                        e.querySelector('.product__image_inner') && (e.querySelector('.product__image_inner').style.display = '');
                        e.querySelector('.play_button') && (e.querySelector('.play_button').style.display = 'flex');
                        e.querySelector('.image_button') && (e.querySelector('.image_button').style.display = 'none');
                        e.setAttribute('data-type','video');
                    });
                    
                    if(btnType=="video"){
                        if(checkForMobile()){
                            //in mobile
                            if (this.querySelector('iframe')) {
                                this.querySelector('img').style.display = 'none';
                                this.querySelector('iframe').style.opacity = 1;
                                this.querySelector('iframe').classList.add('video-active');
                                this.querySelector('.play_button') && (this.querySelector('.play_button').style.display = 'none');
                                this.querySelector('.image_button') && (this.querySelector('.image_button').style.display = 'flex');
                                this.querySelector('.product__image_inner') && (this.querySelector('.product__image_inner').style.display = 'none');
                                this.setAttribute('data-type','image');
                            }
                        }else{
                            //in desctop
                            const crbpOverlay = document.getElementById('crbpOverlay');
                            if(crbpOverlay){
                                crbpOverlay.style.display = 'flex';
                                document.body.style.overflow = 'hidden';
                                document.getElementById('crbpOverlayIframe').setAttribute('src',"");

                                const videoUrl = this.dataset?.video_url ? String(this.dataset.video_url) : this.getAttribute('data-video_url');
                                document.getElementById('crbpOverlayIframe').setAttribute('src', videoUrl || '');
                            }
                        }
                        
                    }else if(btnType=="image"){
                        this.querySelector('img').style.display = '';
                        this.querySelector('iframe').style.opacity = 0;
                        this.querySelector('iframe').classList.remove('video-active');
                        this.querySelector('.play_button') && (this.querySelector('.play_button').style.display = 'flex');
                        this.querySelector('.image_button') && (this.querySelector('.image_button').style.display = 'none');
                        this.querySelector('.product__image_inner') && (this.querySelector('.product__image_inner').style.display = '');
                        this.setAttribute('data-type','video');
                    }
                    
                });
            }
        },
        initCollapseListView: function name() {
            if (HackWrapper.getElements('.collection__results-list-action')?.length > 0) {
                let viewButtonElements = HackWrapper.getElements('.collection__results-list-action');
                viewButtonElements.forEach(function (element) {
                    element.addEventListener("click", function (e) {
                        e.preventDefault();
                        const tdId = this.dataset.id;
                        const listId = this.dataset.listId;
                        const tdDisplay = this.dataset.display;
                        const tdVideo = this.dataset.video;
                        const tdImage = this.dataset.image;
                        const tdOnerror = this.dataset.onerror;

                        HackWrapper.getElements('.collection__results-list-item--active')?.length > 0 && (HackWrapper.getElements('.collection__results-list-item--active').forEach(i => i.classList.remove('collection__results-list-item--active')));
                        if (HackWrapper.getElements('.' + tdId + '-image-desk')) {
                            HackWrapper.getElements('.' + tdId + '-image-desk').forEach(e => {
                                e.style.display = '';
                                e.setAttribute('src', tdImage);
                                e.setAttribute('onerror', tdOnerror);
                            });
                        }

                        viewButtonElements.forEach(i => document.querySelectorAll('.' + i.dataset.id + '-video-desk') && (document.querySelectorAll('.' + i.dataset.id + '-video-desk').forEach(e => e.src = '')));
                        if (tdDisplay == "true") {
                            const viewDetails = document.querySelector('#' + listId);
                            viewDetails.classList.add('collection__results-list-item--active');
                            viewDetails.setAttribute('data-display', "false");
                            document.querySelectorAll('.' + tdId + '-video-desk').forEach(e => e.src = tdVideo);
                        }
                        tdDisplay == 'true' ? document.getElementById(listId).classList.remove('hidden') : document.getElementById(listId).classList.add('hidden');
                        window.DIAMOND_PLP_SETTING.initShowAndHideIframe();
                    });
                });
            }

            if (HackWrapper.getElements('.accordion-container .accordion-toggle.accordion-details-action-custom')?.length > 0) {
                HackWrapper.getElements('.accordion-container .accordion-toggle.accordion-details-action-custom').forEach(function(element) {
                    element.addEventListener('click', function() {
                        this.nextElementSibling.classList.toggle("hidden");
                        this.classList.toggle('accordion-details--inactive');
                    });
                });
            }
        },
        initAddToCartButton: function() {
            if (HackWrapper.getElements('.purchase.add-to-cart')?.length > 0) {
                let vdbAddToCartElements = HackWrapper.getElements('.purchase.add-to-cart');
                for (let i = 0; i < vdbAddToCartElements?.length; i++) {
                    vdbAddToCartElements[i].addEventListener('click', async function() {
                        let _this = this;
                        let dataSelectItem = this.dataset.selectItem;
                        let productJson = document.getElementById(`${dataSelectItem}-textarea`) && document.getElementById(`${dataSelectItem}-textarea`).innerHTML;
                        let productObj = JSON.parse(productJson);

                        _this.setAttribute('disabled', 'disabled');
                        _this.classList.add('disabled');
                        _this.textContent = 'Adding item...';
                        if (Object.keys(productObj)?.length > 0) {
                            var formData = new FormData();
                            formData.append("action", "add_product_info");
                            formData.append("shop", Shopify.shop);
                            formData.append('product_title', productObj?.long_title);
                            formData.append('product_price', productObj?.total_sales_price);
                            formData.append('stock_id', productObj?.id);
                            formData.append('labgrown_stock_num', productObj?.stock_num);
                            formData.append('product_img', productObj?.image_url?.length > 0 ? productObj?.image_url : `${shopifyFileURL}/no-image.png`);
            
                            let createProductRes = await DIAMOND_PLP_SETTING.fetchData(formData);
                            if (createProductRes?.success == true) {
                                $addDiamondToCartTry = 0;
                                await DIAMOND_PLP_SETTING.addToCart(_this, createProductRes?.data?.var_id, 1, {});
                            }
                        } else {
                            // swal("Oops!", "Something went wrong please try again later!", "error");
                            
                            _this.removeAttribute('disabled', 'disabled');
                            _this.classList.remove('disabled');
                            _this.textContent = 'Add to cart';
                        }
                    });
                }
            }
        }, 
        addToCart: async function(_this, variant_id, quantity = "1", properties = {}) {
            var formData = new FormData();
            formData.append("id", variant_id);
            formData.append("quantity", quantity);
            Object.entries(properties).forEach(entry => {
                const [key, value] = entry;
                formData.append("properties[" + key + "]", value);
            });

            /* const cart = document.querySelector('cart-drawer');
            if (cart) {
                formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
                formData.append('sections_url', window.location.pathname);
                cart.setActiveElement(document.activeElement);
            } */

            await fetch("/cart/add.js", { method: "POST", body: formData })
            .then(response => {
                if (!response.ok) {
                    return response.json().then(errorResponse => {
                        throw { status: response?.status, message: errorResponse?.description };
                    });
                }
                return response.json();
            }).then(async result => {
                location.href = '/cart'; //cart.open();
                _this.removeAttribute('disabled', 'disabled');
                _this.classList.remove('disabled');
                _this.textContent = 'Add to cart';
                return;
            })
            .catch((err) => {
                $addDiamondToCartTry++;
                if ($addDiamondToCartTry > 25) {
                    _this.removeAttribute('disabled', 'disabled');
                    _this.classList.remove('disabled');
                    _this.textContent = 'Add to cart';

                    // swal("Oops!", err?.message, "error");
                    return;
                } else {
                    DIAMOND_PLP_SETTING.addToCart(_this, variant_id, quantity, properties);
                    return;
                }
            });
            _this.innerHTML = 'Add to cart';
            _this.disabled = false;
        },
        removeAccordionClass: async () => {
            HackWrapper.getElements('.accordion-header.accordion-action-custom').forEach(function(ele) {
                const body = ele.nextElementSibling;
                ele.classList.remove("open");
                body.style.display = "none";
            });
            document.getElementById('clairDrawer').classList.remove('open');
        },
        resetAllFiltersFun: async function () {
            let listItemAShapeStyleElements = HackWrapper.getElements('.list-item-a-shape-style');
            listItemAShapeStyleElements.forEach(i => i.dataset.shapeValue == defaultShape ? i.classList.add('selected') : i.classList.remove('selected'));

            objCustomFilterSliderCarat && objCustomFilterSliderCarat.resetSlider();
            objCustomFilterSliderColor && objCustomFilterSliderColor.resetSlider();
            objCustomFilterSliderClarity && objCustomFilterSliderClarity.resetSlider();
            objCustomFilterSliderCut && objCustomFilterSliderCut.resetSlider();
            objCustomFilterSliderPrice && objCustomFilterSliderPrice.resetSlider();
            objCustomFilterSliderRatio && objCustomFilterSliderRatio.resetSlider();
            objCustomFilterSliderTable && objCustomFilterSliderTable.resetSlider();
            objCustomFilterSliderDepth && objCustomFilterSliderDepth.resetSlider();
            objCustomFilterSliderSymmetry && objCustomFilterSliderSymmetry.resetSlider();

            this?.removeAccordionClass();
            DIAMOND_PLP_SETTING.config = {
                shapeValue: defaultShape,
                colorValues: color_array?.length > 0 ? `${color_array[0]},${color_array[color_array?.length-1]}` : '',
                fancyValue: defaultFancy,
                clarityValues: clarity_array?.length > 0 ? `${clarity_array[0]},${clarity_array[clarity_array?.length-1]}` : '',
                cutValues: cut_array?.length > 0 ? `${cut_array[0]},${cut_array[cut_array?.length-1]}` : '',
                symmetryValues: symmetry_array?.length > 0 ? `${symmetry_array[0]},${symmetry_array[symmetry_array?.length-1]}` : '',
                labValues: defaultLab,
                caratMin: defaultCaratMin,
                caratMax: defaultCaratMax,
                priceMin: Number(defaultPriceMin) > 1 ? Currency.convert(defaultPriceMin, 'USD', activeShopifyCurrency).toFixed(2) : defaultPriceMin,
                priceMax: Currency.convert(defaultPriceMax, 'USD', activeShopifyCurrency).toFixed(2),
                depthMin: defaultDepthMin,
                depthMax: defaultDepthMax,
                tableMin: defaultTableMin,
                tableMax: defaultTableMax,
                ratioMin: defaultRatioMin,
                ratioMax: defaultRatioMax,
                sortingField: 'total_sales_price',
                sortingSeq: 'ASC'
            }
            await DIAMOND_PLP_SETTING.callBeforeDiamond();
        }
    }
}();

function checkForMobile(){
    let check = false;
    (function (a) { if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true })(navigator.userAgent || navigator.vendor || window.opera)
    return check
};

let sliderMinPriceElement = HackWrapper.getElement('#custom-filter-slider-min-price-range');
let sliderMaxPriceElement = HackWrapper.getElement('#custom-filter-slider-max-price-range');
let inputMinPriceElement = HackWrapper.getElement('#custom-filter-slider-min-price-input');
let inputMaxPriceElement = HackWrapper.getElement('#custom-filter-slider-max-price-input');

let cut_array = defaultCut?.length > 0 && defaultCut.split(',') || [],
clarity_array = defaultClarity?.length > 0 && defaultClarity.split(',') || [],
color_array = defaultColor?.length > 0 && defaultColor.split(',') || [],
symmetry_array = defaultSymmetry?.length > 0 && defaultSymmetry.split(',') || [];
document.addEventListener('DOMContentLoaded', async () => {
    DIAMOND_PLP_SETTING.config = {
        page_number: 1,
        shapeValue: !HackWrapper.isEmpty(HackWrapper.getUrlParameter('shape')) ? HackWrapper.getUrlParameter('shape') : defaultShape,
        colorValues: color_array?.length > 0 ? `${color_array[0]},${color_array[color_array?.length-1]}` : '',
        //fancyValue: defaultFancy,
        fancyValue: "",
        clarityValues: clarity_array?.length > 0 ? `${clarity_array[0]},${clarity_array[clarity_array?.length-1]}` : '',
        cutValues: cut_array?.length > 0 ? `${cut_array[0]},${cut_array[cut_array?.length-1]}` : '',
        symmetryValues: symmetry_array?.length > 0 ? `${symmetry_array[0]},${symmetry_array[symmetry_array?.length-1]}` : '',
        labValues: defaultLab,
        caratMin: defaultCaratMin,
        caratMax: defaultCaratMax,
        priceMin: Number(defaultPriceMin) > 1 ? Currency.convert(defaultPriceMin, 'USD', activeShopifyCurrency).toFixed(2) : defaultPriceMin,
        priceMax: Currency.convert(defaultPriceMax, 'USD', activeShopifyCurrency).toFixed(2),
        depthMin: defaultDepthMin,
        depthMax: defaultDepthMax,
        tableMin: defaultTableMin,
        tableMax: defaultTableMax,
        ratioMin: defaultRatioMin,
        ratioMax: defaultRatioMax,
        sortingField: 'total_sales_price',
        sortingSeq: 'ASC'
    }

    if(sliderMinPriceElement){
        Number(sliderMinPriceElement.value) > 1 && (sliderMinPriceElement.setAttribute('value', Currency.convert(Number(sliderMinPriceElement.value), 'USD', activeShopifyCurrency).toFixed(2)));
        Number(sliderMinPriceElement.min) > 1 && (sliderMinPriceElement.setAttribute('min', Currency.convert(Number(sliderMinPriceElement.min), 'USD', activeShopifyCurrency).toFixed(2)));
        Number(sliderMinPriceElement.max) > 1 && (sliderMinPriceElement.setAttribute('max', Currency.convert(Number(sliderMinPriceElement.max), 'USD', activeShopifyCurrency).toFixed(2)));
        Number(sliderMinPriceElement.dataset.value) > 1 && (sliderMinPriceElement.setAttribute('data-value', Currency.convert(Number(sliderMinPriceElement.dataset.value), 'USD', activeShopifyCurrency).toFixed(2)));
    }

    if(sliderMaxPriceElement){
        Number(sliderMaxPriceElement.value) > 1 && (sliderMaxPriceElement.setAttribute('value', Currency.convert(Number(sliderMaxPriceElement.value), 'USD', activeShopifyCurrency).toFixed(2)));
        Number(sliderMaxPriceElement.min) > 1 && (sliderMaxPriceElement.setAttribute('min', Currency.convert(Number(sliderMaxPriceElement.min), 'USD', activeShopifyCurrency).toFixed(2)));
        Number(sliderMaxPriceElement.max) > 1 && (sliderMaxPriceElement.setAttribute('max', Currency.convert(Number(sliderMaxPriceElement.max), 'USD', activeShopifyCurrency).toFixed(2)));
        Number(sliderMaxPriceElement.dataset.value) > 1 && (sliderMaxPriceElement.setAttribute('data-value', Currency.convert(Number(sliderMaxPriceElement.dataset.value), 'USD', activeShopifyCurrency).toFixed(2)));
    }

    if(inputMinPriceElement){
        Number(inputMinPriceElement.value) > 1 && (inputMinPriceElement.setAttribute('value', Currency.convert(Number(inputMinPriceElement.value), 'USD', activeShopifyCurrency).toFixed(2)));
        Number(inputMinPriceElement.min) > 1 && (inputMinPriceElement.setAttribute('min', Currency.convert(Number(inputMinPriceElement.min), 'USD', activeShopifyCurrency).toFixed(2)));
        Number(inputMinPriceElement.max) > 1 && (inputMinPriceElement.setAttribute('max', Currency.convert(Number(inputMinPriceElement.max), 'USD', activeShopifyCurrency).toFixed(2)));
        Number(inputMinPriceElement.dataset.value) > 1 && (inputMinPriceElement.setAttribute('data-value', Currency.convert(Number(inputMinPriceElement.dataset.value), 'USD', activeShopifyCurrency).toFixed(2)));
    }    

    if(inputMaxPriceElement){
        Number(inputMaxPriceElement.value) > 1 && (inputMaxPriceElement.setAttribute('value', Currency.convert(Number(inputMaxPriceElement.value), 'USD', activeShopifyCurrency).toFixed(2)));
        Number(inputMaxPriceElement.min) > 1 && (inputMaxPriceElement.setAttribute('min', Currency.convert(Number(inputMaxPriceElement.min), 'USD', activeShopifyCurrency).toFixed(2)));
        Number(inputMaxPriceElement.max) > 1 && (inputMaxPriceElement.setAttribute('max', Currency.convert(Number(inputMaxPriceElement.max), 'USD', activeShopifyCurrency).toFixed(2)));
        Number(inputMaxPriceElement.dataset.value) > 1 && (inputMaxPriceElement.setAttribute('data-value', Currency.convert(Number(inputMaxPriceElement.dataset.value), 'USD', activeShopifyCurrency).toFixed(2)));
    }

    if (!HackWrapper.isEmpty(HackWrapper.getUrlParameter('shape')) && HackWrapper.getElements('.list-item-a-shape-style')?.length > 0) {
        HackWrapper.getElements('.list-item-a-shape-style').forEach(e => {
            e.classList.remove('selected');
            e.dataset.shapeValue == HackWrapper.getUrlParameter('shape') && (e.classList.toggle('selected'));
        });
    }

    await HackWrapper.sleep(500);
    await DIAMOND_PLP_SETTING.callDiamondList();
});

if (HackWrapper.getElements('.set_tab_view')?.length > 0) {
    let setTabViewElements = HackWrapper.getElements('.set_tab_view');
    if (setTabViewElements?.length > 0) {
        setTabViewElements.forEach(function (element) {
            element.addEventListener('click', function (e) {
                const view = this.dataset.view;
                setTabViewElements.forEach(e => e.classList.remove('active'));
                this.classList.add('active');

                HackWrapper.getElements('.clair__results-section--view').forEach(e => e.classList.add('hidden'));
                document.getElementById(`clair${view}View`).classList.remove('hidden');
            }); 
        });
    }
}

if (HackWrapper.getElements('.clair-filter-btn, .clair-all-filters')?.length > 0) {
    HackWrapper.getElements('.clair-filter-btn, .clair-all-filters').forEach(function (btn) {
        btn.addEventListener('click', async function () {
            await DIAMOND_PLP_SETTING.removeAccordionClass();
            document.getElementById('clairDrawer').classList.toggle('open');
            HackWrapper.getElement(`[data-accordion-triger="${this.dataset.trigerEvent}"]`) && (HackWrapper.getElement(`[data-accordion-triger="${this.dataset.trigerEvent}"]`).click());
        });
    });
}

if (HackWrapper.getElements('.clair-drawer-action--close')?.length > 0) {
    HackWrapper.getElements('.clair-drawer-action--close').forEach(function (btn) {
        btn.addEventListener('click', function () {
            document.getElementById('clairDrawer').classList.remove('open');
        });
    });
}

if (HackWrapper.getElements('.accordion-header.accordion-action-custom')?.length > 0) {
    HackWrapper.getElements('.accordion-header.accordion-action-custom').forEach(function(element) {
        element.addEventListener('click', function() {
            const body = this.nextElementSibling;
            const isOpen = this.classList.contains("open");

            if (isOpen) {
                this.classList.remove("open");
                body.style.display = "none";
            } else {
                this.classList.add("open");
                body.style.display = "block";
            }
        });
    });
}

if (HackWrapper.getElements('.list-item-a-shape-style')?.length > 0) {
    let listItemAShapeStyleElements = HackWrapper.getElements('.list-item-a-shape-style');
    if (listItemAShapeStyleElements?.length > 0) {
        for (let i = 0; i < listItemAShapeStyleElements.length; i++) {
            const element = listItemAShapeStyleElements[i];
            element.addEventListener('click', async function (e) {
                const shape_value = this.dataset.shapeValue;
                
                listItemAShapeStyleElements.forEach(i => i.classList.remove('selected'));
                (DIAMOND_PLP_SETTING.config.shapeValue != shape_value && this.classList.toggle('selected'));
                DIAMOND_PLP_SETTING.config.shapeValue = (DIAMOND_PLP_SETTING.config.shapeValue != shape_value ? shape_value : '');
                await DIAMOND_PLP_SETTING?.callBeforeDiamond();
            });
        }
    }
}

if (HackWrapper.getElements('.list-item-a-fancy-style')?.length > 0) {
    let listItemFancyStyleElements = HackWrapper.getElements('.list-item-a-fancy-style');
    if (listItemFancyStyleElements?.length > 0) {
        for (let i = 0; i < listItemFancyStyleElements.length; i++) {
            const element = listItemFancyStyleElements[i];
            element.addEventListener('click', async function (e) {
                const fancy_value = this.dataset.fancyValue;
                
                listItemFancyStyleElements.forEach(i => i.classList.remove('selected'));
                (DIAMOND_PLP_SETTING.config.fancyValue != fancy_value && this.classList.toggle('selected'));
                DIAMOND_PLP_SETTING.config.fancyValue = (DIAMOND_PLP_SETTING.config.fancyValue != fancy_value ? fancy_value : '');
                await DIAMOND_PLP_SETTING?.callBeforeDiamond();
            });
        }
    }
}

if (HackWrapper.getElements('.clairsort-box.stone-plp-item-lab')?.length > 0) {
    HackWrapper.getElements('.clairsort-box.stone-plp-item-lab').forEach(element => {
        element.addEventListener('click', async function(e) {
            e.stopPropagation();
            e.preventDefault();
            DIAMOND_PLP_SETTING.config.labValues = this.dataset.lab;
            await DIAMOND_PLP_SETTING?.callBeforeDiamond();
        }); 
    });
}

if (HackWrapper.getElements('.clairsort-box.stone-plp-sorting-featured')?.length > 0) {
    HackWrapper.getElements('.clairsort-box.stone-plp-sorting-featured').forEach(element => {
        element.addEventListener('click', async function(e) {
            e.stopPropagation();
            e.preventDefault();
            DIAMOND_PLP_SETTING.config.sortingField = this.dataset.sortingField;
            DIAMOND_PLP_SETTING.config.sortingSeq = this.dataset.sortingSeq;
            await DIAMOND_PLP_SETTING?.callBeforeDiamond();
        }); 
    });
}

if (HackWrapper.getElements('.apply-all-filters')?.length > 0) {
    HackWrapper.getElements('.apply-all-filters').forEach(element => {
        element.addEventListener('click', function(e) {
            DIAMOND_PLP_SETTING?.removeAccordionClass();
        }); 
    });
}

if (HackWrapper.getElements('.reset-all-filters')?.length > 0) {
    let resetAllFiltersElements = HackWrapper.getElements('.reset-all-filters');
    for (let i = 0; i < resetAllFiltersElements.length; i++) {
        resetAllFiltersElements[i].addEventListener('click', async function(event) {
            event.stopPropagation();
            event.preventDefault();
            DIAMOND_PLP_SETTING.resetAllFiltersFun();
        });
    }
}

/* Custom Slider Filter */
let objCustomFilterSliderCarat,
    objCustomFilterSliderColor,
    objCustomFilterSliderClarity,
    objCustomFilterSliderCut,
    objCustomFilterSliderPrice,
    objCustomFilterSliderRatio,
    objCustomFilterSliderTable,
    objCustomFilterSliderDepth,
    objCustomFilterSliderSymmetry;
if (document.getElementById('custom-filter-slider-min-carat-range') && document.getElementById('custom-filter-slider-max-carat-range')) {
    objCustomFilterSliderCarat = new customRangeSlider('custom-filter-slider-min-carat-range', 'custom-filter-slider-max-carat-range', 'custom-filter-slider-min-carat-input', 'custom-filter-slider-max-carat-input', null, null, false, async (from, to) => {
        DIAMOND_PLP_SETTING.config.caratMin = from;
        DIAMOND_PLP_SETTING.config.caratMax = to;
        await DIAMOND_PLP_SETTING.callBeforeDiamond();
    });   
}

if (document.getElementById('custom-filter-slider-min-color-range') && document.getElementById('custom-filter-slider-max-color-range')) {
    let colorArray = defaultColor.split(',');
    objCustomFilterSliderColor = new customRangeSlider('custom-filter-slider-min-color-range', 'custom-filter-slider-max-color-range', 'custom-filter-slider-min-color-input', 'custom-filter-slider-max-color-input', null, null, true, async (from, to) => {
        DIAMOND_PLP_SETTING.config.colorValues = `${colorArray[from]},${colorArray[to]}`;
        await DIAMOND_PLP_SETTING.callBeforeDiamond();
    });
}

if (document.getElementById('custom-filter-slider-min-clarity-range') && document.getElementById('custom-filter-slider-max-clarity-range')) {
    let clarityArray = defaultClarity.split(',');
    objCustomFilterSliderClarity = new customRangeSlider('custom-filter-slider-min-clarity-range', 'custom-filter-slider-max-clarity-range', 'custom-filter-slider-min-clarity-input', 'custom-filter-slider-max-clarity-input', null, null, true, async (from, to) => {
        DIAMOND_PLP_SETTING.config.clarityValues = `${clarityArray[from]},${clarityArray[to]}`;
        await DIAMOND_PLP_SETTING.callBeforeDiamond();
    });
}

if (document.getElementById('custom-filter-slider-min-cut-range') && document.getElementById('custom-filter-slider-max-cut-range')) {
    let cutArray = defaultCut.split(',');
    objCustomFilterSliderCut = new customRangeSlider('custom-filter-slider-min-cut-range', 'custom-filter-slider-max-cut-range', 'custom-filter-slider-min-cut-input', 'custom-filter-slider-max-cut-input', null, null, true, async (from, to) => {
        DIAMOND_PLP_SETTING.config.cutValues = `${cutArray[from]},${cutArray[to]}`;
        await DIAMOND_PLP_SETTING.callBeforeDiamond();
    });
}

if (document.getElementById('custom-filter-slider-min-price-range') && document.getElementById('custom-filter-slider-max-price-range')) {
    objCustomFilterSliderPrice = new customRangeSlider('custom-filter-slider-min-price-range', 'custom-filter-slider-max-price-range', 'custom-filter-slider-min-price-input', 'custom-filter-slider-max-price-input', null, null, false, async (from, to) => {
        DIAMOND_PLP_SETTING.config.priceMin = from;
        DIAMOND_PLP_SETTING.config.priceMax = to;
        await DIAMOND_PLP_SETTING.callBeforeDiamond();
    });
    setTimeout(() => {
        sliderMaxPriceElement.setAttribute('value', Currency.convert(Number(sliderMaxPriceElement.value), 'USD', activeShopifyCurrency).toFixed(2));    
    }, 1000);
}

if (document.getElementById('custom-filter-slider-min-ratio-range') && document.getElementById('custom-filter-slider-max-ratio-range')) {
    objCustomFilterSliderRatio = new customRangeSlider('custom-filter-slider-min-ratio-range', 'custom-filter-slider-max-ratio-range', 'custom-filter-slider-min-ratio-input', 'custom-filter-slider-max-ratio-input', null, null, false, async (from, to) => {
        DIAMOND_PLP_SETTING.config.ratioMin = from;
        DIAMOND_PLP_SETTING.config.ratioMax = to;
        await DIAMOND_PLP_SETTING.callBeforeDiamond();
    });
}

if (document.getElementById('custom-filter-slider-min-table-range') && document.getElementById('custom-filter-slider-max-table-range')) {
    objCustomFilterSliderTable = new customRangeSlider('custom-filter-slider-min-table-range', 'custom-filter-slider-max-table-range', 'custom-filter-slider-min-table-input', 'custom-filter-slider-max-table-input', null, null, false, async (from, to) => {
        DIAMOND_PLP_SETTING.config.tableMin = from;
        DIAMOND_PLP_SETTING.config.tableMax = to;
        await DIAMOND_PLP_SETTING.callBeforeDiamond();
    });
}

if (document.getElementById('custom-filter-slider-min-depth-range') && document.getElementById('custom-filter-slider-max-depth-range')) {
    objCustomFilterSliderDepth = new customRangeSlider('custom-filter-slider-min-depth-range', 'custom-filter-slider-max-depth-range', 'custom-filter-slider-min-depth-input', 'custom-filter-slider-max-depth-input', null, null, false, async (from, to) => {
        DIAMOND_PLP_SETTING.config.depthMin = from;
        DIAMOND_PLP_SETTING.config.depthMax = to;
        await DIAMOND_PLP_SETTING.callBeforeDiamond();
    });
}

if (document.getElementById('custom-filter-slider-min-symmetry-range') && document.getElementById('custom-filter-slider-max-symmetry-range')) {
    let symmetryArray = defaultSymmetry.split(',');
    objCustomFilterSliderSymmetry = new customRangeSlider('custom-filter-slider-min-symmetry-range', 'custom-filter-slider-max-symmetry-range', 'custom-filter-slider-min-symmetry-input', 'custom-filter-slider-max-symmetry-input', null, null, true, async (from, to) => {
        DIAMOND_PLP_SETTING.config.symmetryValues = `${symmetryArray[from]},${symmetryArray[to]}`;
        await DIAMOND_PLP_SETTING.callBeforeDiamond();
    });
}
/* END - Custom Filter */

/* parent.window.addEventListener("scroll", function () {
    const collectionGridWrapper = parent.document.querySelector("[data-collection-grid-html]");
    const tableId = parent.document.querySelector("#clairListView");
    const tableBody = parent.document.querySelector("#clairListView tbody");

    if (collectionGridWrapper && collectionGridWrapper.offsetHeight > 0) {
        const scrolledToBottom = parent.window.scrollY + parent.window.innerHeight >= collectionGridWrapper.offsetHeight;
        if (scrolledToBottom) {
            DIAMOND_PLP_SETTING.callDiamondList();
            return;
        }
    }

    if (tableId && tableBody && tableBody.innerHTML.trim() !== "") {
        const tableParent = tableId.parentElement;
        if (tableParent && tableParent.offsetHeight > 0 && parent.window.scrollY + parent.window.innerHeight >= tableParent.offsetHeight) {
            DIAMOND_PLP_SETTING.callDiamondList();
        }
    }
}); */

let isLoading = false;
function handleInfiniteScroll(container) {
    container.addEventListener("scroll", async () => {
        const scrollTop = container.scrollTop;
        const clientHeight = container.clientHeight;
        const scrollHeight = container.scrollHeight;

        if (scrollTop + clientHeight >= scrollHeight - 5 && !isLoading) {
            isLoading = true;
            console.log("AJAX CALL for", container.id);

            // 🔥 AJAX CALL
            await DIAMOND_PLP_SETTING.callDiamondList();
            isLoading = false;
        }
    });
}

// Handle Infinite Scroll for Grid && List Views
handleInfiniteScroll(document.getElementById("clairListView"));
handleInfiniteScroll(document.getElementById("clairGridView"));